require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/$.core').Object.getPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/get-prototype-of.js
// module id = 295
// module chunks = 0